import { api } from 'api'
import { AxiosResponse } from 'axios'
import { path } from 'ramda'

export interface AssignmentShift {
  id: number
  startsAt: string
  endsAt: string
  workersNeeded: number
  numWorkersFilled: number
  locationId: number
  lunchLength: number
  isOrientation: boolean
  location: {
    address: {
      city: string
      state: string
      timezone: string
    }
    name: string
  }
  position: {
    name: string
  }
}

interface AssignmentShiftsResponse {
  name: string
  position: {
    name: string
  }
  shifts: AssignmentShift[]
}

type GetAssignmentShiftsResponseDTO = {
  data: {
    company: {
      assignment: AssignmentShiftsResponse
    }
  }
}

export const getAssignmentShifts = async (
  assignmentId: number
): Promise<AssignmentShiftsResponse> => {
  const data = await api.post<
    GetAssignmentShiftsResponseDTO,
    AxiosResponse<GetAssignmentShiftsResponseDTO>
  >('/company/graphql_dispatch/assignment_shifts_94cc266e', { assignmentId })

  return path(['data', 'data', 'company', 'assignment'], data)
}
